import { actionTypes } from "./constants";
const initialState = {
  authorizeList: {
    list: [],
    total: 0,
  },
  authorizeInfoList: {
    list: [],
    total: 0,
  },
  activeList: {
    list: [],
    total: 0,
  },
  authorizeModel: [],
  activeLog: {
    list: [],
    total: 0,
  },
  authorizeDetail: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_AUTHORIZE_LIST:
      return {
        ...state, authorizeList: action.data, 
      };
    case actionTypes.SET_AUTHORIZE_INFO_LIST:
      return {
        ...state, authorizeInfoList: action.data, 
      };
    case actionTypes.SET_ACTIVE_LIST:
      return {
        ...state, activeList: action.data, 
      };
    case actionTypes.SET_AUTHORIZE_MODEL:
      return {
        ...state, authorizeModel: action.data, 
      };
    case actionTypes.SET_ACTIVE_LOG:
      return {
        ...state, activeLog: action.data, 
      };
    case actionTypes.SET_ACTIVE_DETAIL:
      return {
        ...state, authorizeDetail: action.data, 
      };
    default:
      return state;
  }
};